/*Clase que representa la entidad de Items*/
export class ReviewTest{

    //Constructor de la clase
    constructor(
                //Id del item
                public itemId:number,

                //Contenido html del item
                public content:string,

                //Orden visual del item dentro de una sesion
                public orderVisual:number,

                //Sesion a la que pertenece el iten
                public sesion:number,

                //Sesiones totales de la prueba
                public sesions:number,

                //Total numero de items de la sesion
                public total:number,

                //Nombre de la prueba a la que pertenece el item
                public testName:string,

                //Tipo de item (Single, grid, etc)
                public type:string,
                
                //cantidad de sub items: Para los items de tipo P2 y P4 de inglés
                public itemChild:number,
                
                //Orden del item según armado dentro de una sesion
                public order:number,
                
                /**Total que será mostrado en caso que se presenten items con numeración interna*/
	            public totalVisual:number,
                
                //Flag que indica si tiene o no respuesta
                public answer: Boolean,
                
                //Flag que indica si se ha marcado o no para revisión
                public mark: Boolean,
                
                //Contienen el estilo que se visualiza en la revisión de prueba
                public style: string,
                
                //Indica el ícono que se visualiza en la revisión de prueba
                public icon: string,
                
                /**Valor seleccionado como respuesta */
                public answerValue: string){

    }

}
